<template>
  <footer style="margin-top: 65px;">

    <div style="background: rgb(1 66 152);width: 100%;text-align: center;color: #ffffff">
      <div style="width: 1200px;margin: 0 auto;">
        <div style="padding: 10px 0;position: relative;">
          <p>
<!--              <router-link to="/legaldec" >-->
<!--                <span  style="cursor: pointer;color: white"> 法律声明 </span>-->
<!--              </router-link>-->
<!--             <span>&nbsp;&nbsp;</span>-->
<!--              <router-link to="/contact">-->
<!--                <span style="cursor: pointer;color: white"> 联系我们 </span>-->
<!--              </router-link>-->
<!--              <span>&nbsp;&nbsp;</span>-->
<!--              <router-link to="/about">-->
<!--              <router-link to="/about">-->
<!--                <span style="cursor: pointer;color: white"> 平台介绍 </span>-->
<!--              </router-link>-->

          </p>

          <p>
<!--            <a href="https://beian.miit.gov.cn/" style="color: #FFFFFF" target="_blank"> 粤ICP备2023133949号 </a>-->
<!--            <span>&nbsp;&nbsp;</span>-->
<!--            <a target="_blank" style="color: #FFFFFF" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502053744">京公网安备11010502053744号</a>-->
          </p>

          <p>©2026 特资信大模型·特殊资产价值智评系统</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
    export default {
        name: 'Footer',
        props: {
            //msg: String
        },
        data: function () {
            return {

            }
        }
    }
</script>
<style>
.footer-top {
  height: 216px;
  background: #E22323
}

@media print {
  .footer-top {
    display: none
  }
}

.footer-top .wrapper {
  height: 100%;
  overflow: hidden;
  position: relative
}

.footer-top .wrapper .friendly_link {
  position: absolute;
  width: 380px;
  height: 55px;
  top: 52px;
  left: 300px;
  line-height: 55px
}

.footer-top .wrapper .friendly_link .el-input__inner {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #FFFFFF
}

.footer-top .wrapper .friendly_link span {
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF
}

.footer-top .wrapper .logo {
  float: left;
  width: 270px;
  margin-top: 50px
}

.footer-top .wrapper .tel {
  float: right;
  margin-top: 50px;
  margin-right: 81px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
}

.footer-top .wrapper .tel li:nth-of-type(2n) {
  font-size: 22px;
  margin: 5px 0 10px
}

.footer-top .wrapper .qrcode {
  float: right;
  width: 113px;
  margin-top: 50px
}

.footer-bottom {
  height: 44px;
  background: #666
}

@media print {
  .footer-bottom {
    display: none
  }
}

.footer-bottom .wrapper2 {
  height: 100%;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
}

.footer-bottom .wrapper2 span:nth-last-of-type(2) {
  margin-left: 82px
}

.footer-bottom .wrapper2 span:last-of-type {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right
}

.footer-bottom .wrapper2 ul {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center
}

.footer-bottom .wrapper2 ul li:nth-child(2n) {
  width: 1px;
  height: 10px;
  background: #fff;
  margin: 0 12px
}
.footer-link{
  color: #FFFFFF;
}
.footer-link:hover{
  color: #F03C3C;
}
</style>
